import Controller from "./rides.controller";
import template from "./rides.html";

const rides = {
  template,
  controller: Controller,
};

export default rides;



// WEBPACK FOOTER //
// ./src/pages/rides/rides.component.js